/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_No_TemplateInputs */

const cs_property_legal_no_template = /** @type {(inputs: Property_Legal_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádná právní šablona. Vytvořte ji v Šablonách a pak generujte z tohoto inzerátu.`)
};

const en_property_legal_no_template = /** @type {(inputs: Property_Legal_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No legal template yet. Create one in Templates, then generate from this listing.`)
};

/**
* | output |
* | --- |
* | "No legal template yet. Create one in Templates, then generate from this listing." |
*
* @param {Property_Legal_No_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_no_template = /** @type {((inputs?: Property_Legal_No_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_No_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_no_template(inputs)
	return cs_property_legal_no_template(inputs)
});